import React, { Component } from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { Card } from 'tabler-react';
import client from '../client';
import LocationSelect from '../components/LocationSelect';


const locations = gql`
query locationsWithUserLocations {
  userLocations {
    name
    id
  }
}
`;

const addLocation = gql`
mutation addLocation($location: String!) {
  addLocation(location: $location) {
    name
    id
  }
}
`;

const removeLocation = gql`
mutation removeLocation($id: ID!) {
  removeLocation(id: $id) {
    name
    id
  }
}
`;

class LocationSelectContainer extends Component {
  renderLocations = () => {
    const { selectedLocations } = this.props;
    return (
      <Card.Body>
        <LocationSelect locations={selectedLocations.map(l => l.name)} handleSelectLocation={this.handleSelectLocation} />
      </Card.Body>
    );
  }

  handleSelectLocation = ({ target: { value } }) => {
    const { selectedLocations } = this.props;
    const userLocation = selectedLocations.find(({ name }) => name === value);

    if (userLocation) {
      return client.mutate({
        mutation: removeLocation,
        variables: { id: userLocation.id },
        refetchQueries: ['locationsWithUserLocations'],
        optimisticResponse: {
          __typename: 'Mutation',
          addLocation: selectedLocations.filter(({ name }) => name !== value),
        },
        update: (proxy) => {
          const data = proxy.readQuery({ query: locations });
          data.userLocations = data.userLocations.filter(({ name }) => name !== value);
          proxy.writeQuery({ query: locations, data });
        },
      });
    }
    return client.mutate({
      mutation: addLocation,
      variables: { location: value },
      refetchQueries: ['locationsWithUserLocations'],
      optimisticResponse: {
        __typename: 'Mutation',
        addLocation: {
          name: value,
          id: null,
          __typename: 'Location',
        },
      },
      update: (proxy) => {
        const data = proxy.readQuery({ query: locations });
        data.userLocations.push({ __typename: 'Location', name: value, id: null });
        proxy.writeQuery({ query: locations, data });
      },
    });
  }

  render() {
    return (
      <Card>
        <Card.Header>
          {'Filter Alerts by Location'}
        </Card.Header>
        {this.renderLocations()}
      </Card>
    );
  }
}

export default function () {
  return (
    <Query query={locations}>
      {(({ data: { userLocations = [] } = {} }) => (
        <LocationSelectContainer selectedLocations={userLocations} />
      ))}
    </Query>
  );
}



// WEBPACK FOOTER //
// ./src/keywords/locationSelect.js